export default __webpack_public_path__ + "static/media/Logo_Angular.2a94d7a4.png";